exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center .vs-table-text {\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n}\n.content-display-detail .vs-popup--content {\n  height: 100% !important;\n  position: relative !important;\n}\n.vs-tooltip {\n  z-index: 100000;\n}\n", ""]);

// exports
